import React from "react";
import CdrEvents from "./CdrEvents";
import CdrCallRecording from "./CdrCallRecording";
import { FaRegCircleUser } from "react-icons/fa6";
const formatDuration = (value, isMilliseconds = false) => {
  if (!value) return "00:00";

  const totalSeconds = isMilliseconds ? Math.floor(value / 1000) : value;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};
const formatDateTime = (date) => {
  if (!date) return "N/A";
  const timestamp = new Date(date);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timestamp.toLocaleString(undefined, {
    timeZone: userTimeZone,
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

const CdrDetails = ({ call }) => {
  return (
    <div className="p-6 bg-primary-light dark:bg-primary-dark text-text-primary-light dark:text-text-primary-dark">
      {/* Fila 1: Detalles de la llamada */}
      <div className="mb-8">
        <h1 className="text-xl font-semibold text-left mb-4">Call Details</h1>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p>
              <span className="font-bold">ID:</span> {call.id}
            </p>
            <p>
              <span className="font-bold">Direction:</span> {call.direction}
            </p>
            <p>
              <span className="font-bold">Init Date:</span>{" "}
              {formatDateTime(call.initDate)}
            </p>
            <p>
              <span className="font-bold">End Date:</span>{" "}
              {formatDateTime(call.endDate)}
            </p>
            <p>
              <span className="font-bold">Duration:</span>{" "}
              {formatDuration(call.durationTime) || "N/A"}
            </p>
          </div>
          <div>
            <p>
              <span className="font-bold">Source Number:</span> {call.srcNumber}
            </p>
            <p>
              <span className="font-bold">Destination Number:</span>{" "}
              {call.dstNumber}
            </p>
            <div className="flex items-center flex-wrap gap-2 mt-2">
              {/* Badge para Queue Name */}
              {call.queueName && (
                <div className="text-sm font-medium rounded-full py-1 px-3 bg-purple-100 dark:bg-purple-800 text-purple-700 dark:text-purple-300">
                  {call.queueName.startsWith("20")
                    ? call.queueName.slice(5)
                    : call.queueName}
                </div>
              )}

              {/* Badge para Call Result */}
              <div
                className={`text-sm font-medium rounded-full py-1 px-3 text-white ${
                  call.callResult === "Attended"
                    ? "bg-green-500"
                    : call.callResult === "Canceled" ||
                      call.callResult === "Abandon"
                    ? "bg-blue-500"
                    : "bg-purple-500"
                }`}
              >
                {call.callResult}
              </div>

              {/* Badge para Agent */}
              {call.agent && (
                <div className="flex items-center text-sm font-medium gap-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full py-1 px-3">
                  <FaRegCircleUser size={15} />
                  {call.agent}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Fila 2: Componentes horizontales con línea divisoria */}
      <div className="grid grid-cols-[1fr_2px_1fr] gap-4">
        {/* Call Recording */}
        <div className="flex flex-col">
          <h2 className="text-lg font-semibold text-left">
            Call Recording and transcription
          </h2>
          <div className="flex-grow flex items-center justify-center">
            <CdrCallRecording id={call.callRecording} />
          </div>
        </div>

        {/* Línea Divisoria */}
        <div className="h-[80%] mx-auto bg-gradient-to-b from-transparent via-gray-300 dark:via-gray-700 to-transparent w-[2px]"></div>

        {/* Call Events */}
        <div className="flex flex-col">
          <h2 className="text-lg font-semibold text-left">Events</h2>
          <div className="flex-grow flex items-center justify-start">
            <CdrEvents id={call.id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CdrDetails;
